"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GalleryStore_1 = require("../stores/GalleryStore");
class EntitiesActions {
    static setGalleryName(context, name, callback) {
        context.dispatch(GalleryStore_1.SET_GALLERY_OPEN, name);
        callback();
    }
    static getGallery(context, payload, callback) {
        const name = payload.name;
        const store = context.getStore('GalleryStore');
        if (store.getEntities().results.length === 0) {
            context.service.read('galleries', {}, {}, (err, searchResult) => {
                store.saveEntities(searchResult);
                EntitiesActions.setGalleryName(context, name, callback);
            });
        }
        else {
            EntitiesActions.setGalleryName(context, name, callback);
        }
    }
    static getGalleries(context, payload, callback) {
        context.service.read('galleries', {}, {}, (err, searchResult) => {
            context.dispatch(GalleryStore_1.GALLERIES_RECEIVED, searchResult);
            callback();
        });
    }
    static sendEnquiry(context, payload, callback) {
        context.service.create('enquiry', {}, payload, callback);
    }
}
exports.default = EntitiesActions;
